import { Clock, Loader2 } from "@/components/icons"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

export function DemoGenerationProgress() {
  return (
    <Card className="border-l-primary w-full border-l-4 sm:max-w-sm">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Loader2 className="h-4 w-4 animate-spin" />
          Generating video...
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="text-muted-foreground flex items-center gap-2 text-xs">
          <Clock className="h-3 w-3" />
          <span>Est. 45s remaining</span>
        </div>
        <p className="text-muted-foreground text-xs">
          Job ID: <code className="bg-muted rounded px-1">demo-job-12345</code>
        </p>
      </CardContent>
    </Card>
  )
}
